module.exports = __webpack_public_path__ + "static/media/hands_21.14eb4a0d.svg";